import { createHashRouter } from "react-router-dom";

// Importing layout components
import OnboardingLayout from "./components/_layouts/OnboardingLayout";
import DashboardLayout from "./components/_layouts/DashboardLayout";

// Importing onboarding components
import SignIn from "./components/onboarding/SignIn";
import SignUp from "./components/onboarding/SignUp";
import ForgotPassword from "./components/onboarding/ForgotPassword";
import OtpVerification from "./components/onboarding/OtpVerification";
import ResetPassword from "./components/onboarding/ResetPassword";

// Importing dashboard components
import Organization from "./components/features/Organizaton/Organization";
import OrganizationLayout from "./components/features/Organizaton/OrganizationLayout";
import Campus from "./components/features/Organizaton/Campus";
import AssemblyPoint from "./components/features/Organizaton/AssemblyPoint";
import Locations from "./components/features/Organizaton/Locations";
import Zones from "./components/features/Organizaton/Zones";
import Courses from "./components/features/Organizaton/Courses";
import CourseCompletions from "./components/features/Organizaton/CourseCompletions";
import Users from "./components/features/Users";
import Setting from "./components/features/Setting";
import Locate from "./components/features/Locate";
import Guest from "./components/features/Guest";
import NotFound from "./components/features/NotFound";
import Canvas from "./components/features/Canvas";
import Privacy from "./components/features/Privacy";
import Profile from "./components/features/Profile";
import QuestTypePackage from "./components/features/QuestTypePackage";
import PaymentMethod from "./components/features/PaymentMethod";
import ManageSubscription from "./components/features/ManageSubscription";
import Guide from "./components/features/Guide";

// Defining routes for the onboarding process
const onboardingRoutes = [
  { index: true, element: <SignIn /> }, // Default route for onboarding: SignIn component
  { path: "signup", element: <SignUp /> }, // SignUp route
  { path: "forgot-password", element: <ForgotPassword /> }, // ForgotPassword route
  { path: "verification", element: <OtpVerification /> }, // OtpVerification route
  { path: "reset-password", element: <ResetPassword /> }, // ResetPassword route
];

// Defining routes for the organization features
const organizationRoutes = [
  { index: true, element: <Organization /> }, // Default route for organization: Organization component
  { path: "campus", element: <Campus /> }, // Campus route
  { path: "assemblyPoint", element: <AssemblyPoint /> }, // AssemblyPoint route
  { path: "locations", element: <Locations /> }, // Locations route
  { path: "zones", element: <Zones /> }, // Zones route
  { path: "courses", element: <Courses /> }, // Courses route
  { path: "courseCompletions", element: <CourseCompletions /> }, // CourseCompletions route
  { path: "Canvas", element: <Canvas /> }, // Canvas route
];

// Defining routes for the dashboard
const dashboardRoutes = [
  {
    path: "organization",
    element: <OrganizationLayout />,
    children: organizationRoutes,
  }, // Organization layout with nested routes
  { path: "users", element: <Users /> }, // Users route
  { path: "setting", element: <Setting /> }, // Setting route
  { path: "profile", element: <Profile /> }, // Setting route
  { path: "locate", element: <Locate /> }, // Locate route
  { path: "guest", element: <Guest /> }, // Guest route
  { path: "quest-type-package", element: <QuestTypePackage /> }, // Quest Type Package route
  { path: "payment-method", element: <PaymentMethod /> }, // Payment Method route
  { path: "manage-subscription", element: <ManageSubscription /> }, // Manage Subscription route
  { path: "guide", element: <Guide /> }, // Guide (training videos) route
];

// Creating the main router with defined routes
const router = createHashRouter([
  {
    path: "/", // Root path
    element: <OnboardingLayout />, // Onboarding layout for root path
    children: onboardingRoutes, // Nested onboarding routes
  },
  {
    path: "/", // Root path
    element: <DashboardLayout />, // Dashboard layout for root path
    children: dashboardRoutes, // Nested dashboard routes
  },
  {
    path: "privacy-policy",
    element: <Privacy />,
  },
  {
    path: "*", // Catch-all for undefined routes
    element: <NotFound />,
  },
]);

// Exporting the router to be used in the application
export default router;